import { Dialog } from '@material-ui/core';
import React from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

function PackagePickerModal(props: Props) {
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth={false} style={{ borderRadius: 0 }}>
      {props.children}
    </Dialog>
  );
}

export default PackagePickerModal;
